// This file is auto-generated. Do not edit directly.

import { StaticImageData } from 'next/image';

import flexhegs_nowatermark_inexpandable_png from '../public/flexhegs-nowatermark-inexpandable.png';
import hao2024_nowatermark_inexpandable_png from '../public/hao2024-nowatermark-inexpandable.png';
import ida_nowatermark_inexpandable_png from '../public/ida-nowatermark-inexpandable.png';
import metr_extended_nowatermark_inexpandable_png from '../public/metr-extended-nowatermark-inexpandable.png';
import combined_headline_inexpandable_png from '../public/combined-headline-inexpandable.png';
import epochLLMprice_nowatermark_png from '../public/epochLLMprice-nowatermark.png';
import takeoff_takeoff_timeline_inexpandable_png from '../public/takeoff/takeoff-timeline-inexpandable.png';
import combined_headline_png from '../public/combined-headline.png';
import metrhorizon_nowatermark_png from '../public/metrhorizon-nowatermark.png';
import simple_combined_headline_png from '../public/simple-combined-headline.png';
import metrsuite_nowatermark_png from '../public/metrsuite-nowatermark.png';
import metrbreakdown_nowatermark_png from '../public/metrbreakdown-nowatermark.png';
import metrrebenchsaturation_nowatermark_png from '../public/metrrebenchsaturation-nowatermark.png';
import timelines_forecast_nowatermark_png from '../public/timelines-forecast-nowatermark.png';
import metrgaps_nowatermark_png from '../public/metrgaps-nowatermark.png';
import combined_inputs_png from '../public/combined-inputs.png';
import takeoff_takeoff_timeline_png from '../public/takeoff/takeoff-timeline.png';
import epochranddflow_nowatermark_png from '../public/epochranddflow-nowatermark.png';
import einstein_png from '../public/einstein.png';
import security_FIGURE__2_png from '../public/security/FIGURE\_2.png';
import security_FIGURE__6_png from '../public/security/FIGURE\_6.png';
import security_FIGURE__7_png from '../public/security/FIGURE\_7.png';
import security_FIGURE__8_png from '../public/security/FIGURE\_8.png';
import security_FIGURE__9_png from '../public/security/FIGURE\_9.png';
import security_FIGURE__10_png from '../public/security/FIGURE\_10.png';
import security_FIGURE__1_png from '../public/security/FIGURE\_1.png';
import security_FIGURE__3_png from '../public/security/FIGURE\_3.png';
import cybench_nowatermark_png from '../public/cybench-nowatermark.png';
import security_FIGURE__11_png from '../public/security/FIGURE\_11.png';
import security_FIGURE__5_png from '../public/security/FIGURE\_5.png';
import security_FIGURE__12_png from '../public/security/FIGURE\_12.png';
import security_FIGURE__13_png from '../public/security/FIGURE\_13.png';
import goals_cotra_nowatermark_png from '../public/goals-cotra-nowatermark.png';
import goals_overview_png from '../public/goals-overview.png';
import goals_written_png from '../public/goals-written.png';
import goals_overview2_png from '../public/goals-overview2.png';
import goals_4o1_nowatermark_png from '../public/goals-4o1-nowatermark.png';
import goals_4o2_nowatermark_png from '../public/goals-4o2-nowatermark.png';

const optimizedImages: Record<string, StaticImageData> = {
  '/flexhegs-nowatermark-inexpandable.png': flexhegs_nowatermark_inexpandable_png,
  '/hao2024-nowatermark-inexpandable.png': hao2024_nowatermark_inexpandable_png,
  '/ida-nowatermark-inexpandable.png': ida_nowatermark_inexpandable_png,
  '/metr-extended-nowatermark-inexpandable.png': metr_extended_nowatermark_inexpandable_png,
  '/combined-headline-inexpandable.png': combined_headline_inexpandable_png,
  '/epochLLMprice-nowatermark.png': epochLLMprice_nowatermark_png,
  '/takeoff/takeoff-timeline-inexpandable.png': takeoff_takeoff_timeline_inexpandable_png,
  '/combined-headline.png': combined_headline_png,
  '/metrhorizon-nowatermark.png': metrhorizon_nowatermark_png,
  '/simple-combined-headline.png': simple_combined_headline_png,
  '/metrsuite-nowatermark.png': metrsuite_nowatermark_png,
  '/metrbreakdown-nowatermark.png': metrbreakdown_nowatermark_png,
  '/metrrebenchsaturation-nowatermark.png': metrrebenchsaturation_nowatermark_png,
  '/timelines-forecast-nowatermark.png': timelines_forecast_nowatermark_png,
  '/metrgaps-nowatermark.png': metrgaps_nowatermark_png,
  '/combined-inputs.png': combined_inputs_png,
  '/takeoff/takeoff-timeline.png': takeoff_takeoff_timeline_png,
  '/epochranddflow-nowatermark.png': epochranddflow_nowatermark_png,
  '/einstein.png': einstein_png,
  '/security/FIGURE\_2.png': security_FIGURE__2_png,
  '/security/FIGURE\_6.png': security_FIGURE__6_png,
  '/security/FIGURE\_7.png': security_FIGURE__7_png,
  '/security/FIGURE\_8.png': security_FIGURE__8_png,
  '/security/FIGURE\_9.png': security_FIGURE__9_png,
  '/security/FIGURE\_10.png': security_FIGURE__10_png,
  '/security/FIGURE\_1.png': security_FIGURE__1_png,
  '/security/FIGURE\_3.png': security_FIGURE__3_png,
  '/cybench-nowatermark.png': cybench_nowatermark_png,
  '/security/FIGURE\_11.png': security_FIGURE__11_png,
  '/security/FIGURE\_5.png': security_FIGURE__5_png,
  '/security/FIGURE\_12.png': security_FIGURE__12_png,
  '/security/FIGURE\_13.png': security_FIGURE__13_png,
  '/goals-cotra-nowatermark.png': goals_cotra_nowatermark_png,
  '/goals-overview.png': goals_overview_png,
  '/goals-written.png': goals_written_png,
  '/goals-overview2.png': goals_overview2_png,
  '/goals-4o1-nowatermark.png': goals_4o1_nowatermark_png,
  '/goals-4o2-nowatermark.png': goals_4o2_nowatermark_png,
};

export default optimizedImages;
